import BindBankDialog from '@/components/common/dialog/BindBank'

export default {
  components: {
    BindBankDialog,
  },
  data() {
    return {
      bindBankDialogVisible: false,
    }
  },
  methods: {
    hideBindBankDialog() {
      this.bindBankDialogVisible = false
    },
  },
}
